import { render, staticRenderFns } from "./proxyUserList.vue?vue&type=template&id=52073b90"
import script from "./proxyUserList.vue?vue&type=script&lang=js"
export * from "./proxyUserList.vue?vue&type=script&lang=js"
import style0 from "./proxyUserList.vue?vue&type=style&index=0&id=52073b90&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports